/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { typedDependencies } from './dependenciesTyped.generated.js';
import { createIsNaN } from '../../factoriesAny.js';
export var isNaNDependencies = {
  typedDependencies,
  createIsNaN
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/esm/entry/dependenciesAny/dependenciesIsNaN.generated.js
// module id = MhKe
// module chunks = 3